"use client";

import { useContext } from "react";

import { TrackingContext } from "../contexts/TrackingContext";

/**
 * Hook to access tracking functionality through the TrackingProvider
 *
 * @example
 * ```tsx
 * const { track } = useTracker();
 *
 * // Track a button click interaction
 * track("interaction", {
 *   category: "button",
 *   action: "click",
 *   label: "cta-main",
 *   properties: {
 *     buttonId: "cta-main",
 *     buttonText: "Get Started"
 *   }
 * });
 *
 * // Track a page view
 * track("pageView", {
 *   pagePath: "/products",
 *   pageTitle: "Products Page"
 * });
 *
 * // Track a custom event
 * track("custom", {
 *   category: "video",
 *   action: "play",
 *   label: "intro",
 *   value: 120
 * });
 * ```
 */
export function useTracker() {
  const { track } = useContext(TrackingContext);
  return { track };
}
